import { render } from "./TechSection.vue?vue&type=template&id=6bb26268&scoped=true"
import script from "./TechSection.vue?vue&type=script&lang=js"
export * from "./TechSection.vue?vue&type=script&lang=js"

import "./TechSection.vue?vue&type=style&index=0&id=6bb26268&scoped=true&lang=scss"
import "./TechSection.vue?vue&type=style&index=1&id=6bb26268&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb26268"]])

export default __exports__